import {NgModule} from '@angular/core';
import {SearchEngineComponent} from './search-engine.component';
import {SharedModule} from '../shared/shared.module';
import {EngineHolidayModalDestinationsComponent} from './components/engine-holiday-modal-destinations/engine-holiday-modal-destinations.component';
import {EngineHolidayControlAirportComponent} from './components/engine-holiday-control-airport/engine-holiday-control-airport.component';
import {EngineTabsComponent} from './components/engine-tabs/engine-tabs.component';
import {EngineBodyComponent} from './components/engine-body/engine-body.component';
import {EngineHolidayComponent} from './components/engine-holiday/engine-holiday.component';
import {EngineCruiseComponent} from './components/engine-cruise/engine-cruise.component';
import {GroupAirportsPipe} from './pipes/group-airports.pipe';
import {EngineCruiseModalItinerariesComponent} from './components/engine-cruise-modal-itineraries/engine-cruise-modal-itineraries.component';
import {EngineCruiseSelectDateComponent} from './components/engine-cruise-select-date/engine-cruise-select-date.component';
import {EngineCruiseSelectHarbourComponent} from './components/engine-cruise-select-harbour/engine-cruise-select-harbour.component';
import {EngineCruiseSelectShipComponent} from './components/engine-cruise-select-ship/engine-cruise-select-ship.component';
import {EngineHolidayControlDatepickerComponent} from './components/engine-holiday-control-datepicker/engine-holiday-control-datepicker.component';
import {HolidayDestinationsListComponent} from './components/holiday-destinations-list/holiday-destinations-list.component';
import {HolidayDestinationsSliderComponent} from './components/holiday-destinations-slider/holiday-destinations-slider.component';
import {EngineGuestsModalComponent} from './components/engine-guests-modal/engine-guests-modal.component';
import {OccupancyPipe} from './pipes/occupancy.pipe';
import {EngineControlGuestsComponent} from './components/engine-control-guests/engine-control-guests.component';
import {EngineHolidayModalAirportComponent} from './components/engine-holiday-modal-airport/engine-holiday-modal-airport.component';
import {EngineHolidayModalDatepickerComponent} from './components/engine-holiday-modal-datepicker/engine-holiday-modal-datepicker.component';
import {EngineMerlinxFlightsComponent} from './components/engine-merlinx-flights/engine-merlinx-flights.component';
import {EngineMerlinxHotelsComponent} from './components/engine-merlinx-hotels/engine-merlinx-hotels.component';
import {EngineMerlinxParkingsComponent} from './components/engine-merlinx-parkings/engine-merlinx-parkings.component';
import {EngineMerlinxCarrentalComponent} from './components/engine-merlinx-carrental/engine-merlinx-carrental.component';
import {EngineMerlinxPassengersModalComponent} from './components/engine-merlinx-passengers-modal/engine-merlinx-passengers-modal.component';
import { EngineBusComponent } from './components/engine-bus/engine-bus.component';
import { EngineSmartboxComponent } from './components/engine-smartbox/engine-smartbox.component';
import { EngineWelcomeToItalyComponent } from './components/engine-welcome-to-italy/engine-welcome-to-italy.component';
import { EngineWelcomeToItalySmartTravelComponent } from './components/engine-welcome-to-italy-smart-travel/engine-welcome-to-italy-smart-travel.component';
import { EngineWelcomeToItalyExperiencesComponent } from './components/engine-welcome-to-italy-experiences/engine-welcome-to-italy-experiences.component';
import { EngineWelcomeToItalyDynamicItineraryComponent } from './components/engine-welcome-to-italy-dynamic-itinerary/engine-welcome-to-italy-dynamic-itinerary.component';
import { EngineWelcomeToItalyPassengersModalComponent } from './components/engine-welcome-to-italy-passengers-modal/engine-welcome-to-italy-passengers-modal.component';
import { EngineWelcomeToItalyDurationModalComponent } from './components/engine-welcome-to-italy-duration-modal/engine-welcome-to-italy-duration-modal.component';
import { NgSelectSortByPipe } from './pipes/ng-select-sort-by.pipe';
import { EngineWelcomeToItalyTourDiGruppoComponent } from './components/engine-welcome-to-italy-tour-di-gruppo/engine-welcome-to-italy-tour-di-gruppo.component';
import {RemoveItineraryPipe} from './pipes/remove-itinerary.pipe';
import { EngineTourControlDatepickerComponent } from './components/engine-tour-control-datepicker/engine-tour-control-datepicker.component';
import { EngineTourModalDatepickerComponent } from './components/engine-tour-modal-datepicker/engine-tour-modal-datepicker.component';
import { EngineTourModalDestinationsComponent } from './components/engine-tour-modal-destinations/engine-tour-modal-destinations.component';
import { EngineTourComponent } from './components/engine-tour/engine-tour.component';


@NgModule({
  declarations: [
    SearchEngineComponent,
    EngineHolidayModalDestinationsComponent,
    EngineHolidayControlAirportComponent,
    EngineTabsComponent,
    EngineBodyComponent,
    EngineHolidayComponent,
    EngineCruiseComponent,
    GroupAirportsPipe,
    RemoveItineraryPipe,
    EngineCruiseModalItinerariesComponent,
    EngineCruiseSelectDateComponent,
    EngineCruiseSelectHarbourComponent,
    EngineCruiseSelectShipComponent,
    EngineHolidayControlDatepickerComponent,
    HolidayDestinationsListComponent,
    HolidayDestinationsSliderComponent,
    EngineGuestsModalComponent,
    OccupancyPipe,
    EngineControlGuestsComponent,
    EngineHolidayModalAirportComponent,
    EngineHolidayModalDatepickerComponent,
    EngineMerlinxFlightsComponent,
    EngineMerlinxHotelsComponent,
    EngineMerlinxParkingsComponent,
    EngineMerlinxCarrentalComponent,
    EngineMerlinxPassengersModalComponent,
    EngineBusComponent,
    EngineSmartboxComponent,
    EngineWelcomeToItalyComponent,
    EngineWelcomeToItalySmartTravelComponent,
    EngineWelcomeToItalyExperiencesComponent,
    EngineWelcomeToItalyDynamicItineraryComponent,
    EngineWelcomeToItalyPassengersModalComponent,
    EngineWelcomeToItalyDurationModalComponent,
    NgSelectSortByPipe,
    EngineWelcomeToItalyTourDiGruppoComponent,
    EngineTourModalDestinationsComponent,
    EngineTourModalDatepickerComponent,
    EngineTourControlDatepickerComponent,
    EngineTourComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [SearchEngineComponent, EngineHolidayModalDestinationsComponent],
  providers: [GroupAirportsPipe]
})
export class SearchEngineModule {
}
